import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomCmsItemComponent} from './custom-cms-item.component';
import {CmsConfig, ConfigModule, I18nModule, UrlModule} from '@spartacus/core';
import {RouterModule} from '@angular/router';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';


@NgModule({
  declarations: [CustomCmsItemComponent],
  exports: [CustomCmsItemComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    GenericLinkModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSItemComponent: {
          component: CustomCmsItemComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCmsItemModule { }
